import type { RBACConfig } from '~/types/rbac';

export const rbacConfig: RBACConfig = {
  roles: [
    {
      role: 'admin',
      resources: [
        {
          resource: 'fund',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'portfolio',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'dashboard',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'document',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'workflow',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'setting',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'user',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'analytics',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'admin_panel',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:allocation',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:allocation_table',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:proposed_portfolio',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:ai_recommendations',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:recommendation_report',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:projected_risk_metrics',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:risk_alerts',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:market_analysis',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:news_impact_analysis',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:expected_impact',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:ems_blotter',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:fund_list',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:companies_per_sector',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:invested_per_sector',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:aggr_gross_irr',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:aggr_gross_moic',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:dynamic_pie_chart',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:dynamic_histogram',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:dynamic_table',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:historical_returns',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:forward_returns',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:asset_breakdown',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:correlation_cluster',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:sector_allocation',
          actions: ['read', 'edit', 'delete', 'create'],
        },
      ],
    },
    {
      role: 'test_user',
      resources: [
        {
          resource: 'fund',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'portfolio',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'dashboard',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'document',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'workflow',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'setting',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'user',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'analytics',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'admin_panel',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:allocation',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:allocation_table',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:proposed_portfolio',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:ai_recommendations',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:recommendation_report',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:projected_risk_metrics',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:risk_alerts',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:market_analysis',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:news_impact_analysis',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:expected_impact',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:ems_blotter',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:fund_list',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:companies_per_sector',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:invested_per_sector',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:aggr_gross_irr',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:aggr_gross_moic',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:dynamic_pie_chart',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:dynamic_histogram',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:dynamic_table',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:historical_returns',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:forward_returns',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:asset_breakdown',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:correlation_cluster',
          actions: ['read', 'edit', 'delete', 'create'],
        },
        {
          resource: 'widget:sector_allocation',
          actions: ['read', 'edit', 'delete', 'create'],
        },
      ],
    },
    {
      role: 'member',
      resources: [
        {
          resource: 'portfolio',
          actions: ['read', 'create', 'delete'],
        },
        {
          resource: 'document',
          actions: ['read'],
        },
        {
          resource: 'dashboard',
          actions: ['read', 'create', 'edit', 'delete'],
        },
        {
          resource: 'widget',
          actions: ['read'],
        },
        {
          resource: 'widget:allocation',
          actions: ['read'],
        },
        {
          resource: 'widget:allocation_table',
          actions: ['read'],
        },
        {
          resource: 'widget:proposed_portfolio',
          actions: ['read'],
        },
        {
          resource: 'widget:ai_recommendations',
          actions: ['read'],
        },
        {
          resource: 'widget:recommendation_report',
          actions: ['read'],
        },
        {
          resource: 'widget:projected_risk_metrics',
          actions: ['read'],
        },
        {
          resource: 'widget:risk_alerts',
          actions: ['read'],
        },
        {
          resource: 'widget:market_analysis',
          actions: ['read'],
        },
        {
          resource: 'widget:news_impact_analysis',
          actions: ['read'],
        },
        {
          resource: 'widget:expected_impact',
          actions: ['read'],
        },
        {
          resource: 'widget:historical_returns',
          actions: ['read'],
        },
        {
          resource: 'widget:forward_returns',
          actions: ['read'],
        },
        {
          resource: 'widget:asset_breakdown',
          actions: ['read'],
        },
        {
          resource: 'widget:correlation_cluster',
          actions: ['read'],
        },
        {
          resource: 'widget:sector_allocation',
          actions: ['read'],
        },
      ],
    },
    {
      role: 'portfolio_owner',
      resources: [
        {
          resource: 'portfolio',
          actions: ['read', 'create'],
        },
        {
          resource: 'document',
          actions: ['read'],
        },
        {
          resource: 'dashboard',
          actions: ['read', 'create', 'edit', 'delete'],
        },
        {
          resource: 'widget',
          actions: ['read'],
        },
        {
          resource: 'widget:allocation',
          actions: ['read'],
        },
        {
          resource: 'widget:allocation_table',
          actions: ['read'],
        },
        {
          resource: 'widget:proposed_portfolio',
          actions: ['read'],
        },
        {
          resource: 'widget:ai_recommendations',
          actions: ['read'],
        },
        {
          resource: 'widget:recommendation_report',
          actions: ['read'],
        },
        {
          resource: 'widget:projected_risk_metrics',
          actions: ['read'],
        },
        {
          resource: 'widget:risk_alerts',
          actions: ['read'],
        },
        {
          resource: 'widget:market_analysis',
          actions: ['read'],
        },
        {
          resource: 'widget:news_impact_analysis',
          actions: ['read'],
        },
        {
          resource: 'widget:expected_impact',
          actions: ['read'],
        },
        {
          resource: 'widget:historical_returns',
          actions: ['read'],
        },
        {
          resource: 'widget:forward_returns',
          actions: ['read'],
        },
        {
          resource: 'widget:asset_breakdown',
          actions: ['read'],
        },
        {
          resource: 'widget:correlation_cluster',
          actions: ['read'],
        },
        {
          resource: 'widget:sector_allocation',
          actions: ['read'],
        },
      ],
    },
  ],
};
